import type { Room } from '@hollowveil/shared';
import { roomVillageHouse } from './villageHouse';
import { roomForestGarden } from './forestGarden';
import { roomAncientRuins } from './ancientRuins';
import { roomShadowTemple } from './shadowTemple';
import { roomCrystalLabyrinth } from './crystalLabyrinth';
import { roomForbiddenLibrary } from './forbiddenLibrary';
import { roomCelestialObservatory } from './celestialObservatory';
import { roomFinalSanctuary } from './finalSanctuary';
import { roomTowerAscension } from './towerAscension';
import { roomHawkinsSuburb } from './hawkinsSuburb';
import { roomJurassicPark } from './jurassicPark';
import { roomMiddleEarth } from './middleEarth';
import { roomWonderland } from './wonderland';
import { roomNightmareChristmas } from './nightmareChristmas';
import { roomWinterfell } from './winterfell';

export {
  roomVillageHouse,
  roomForestGarden,
  roomAncientRuins,
  roomShadowTemple,
  roomCrystalLabyrinth,
  roomForbiddenLibrary,
  roomCelestialObservatory,
  roomFinalSanctuary,
  roomTowerAscension,
  roomHawkinsSuburb,
  roomJurassicPark,
  roomMiddleEarth,
  roomWonderland,
  roomNightmareChristmas,
  roomWinterfell,
};

export const allRooms: Room[] = [
  roomVillageHouse,
  roomForestGarden,
  roomAncientRuins,
  roomShadowTemple,
  roomCrystalLabyrinth,
  roomForbiddenLibrary,
  roomCelestialObservatory,
  roomFinalSanctuary,
  roomTowerAscension,
  roomHawkinsSuburb,
  roomJurassicPark,
  roomMiddleEarth,
  roomWonderland,
  roomNightmareChristmas,
  roomWinterfell,
];
